import { render, staticRenderFns } from "./LiveClassBulkUploader.vue?vue&type=template&id=35c590e6&scoped=true&"
import script from "./LiveClassBulkUploader.vue?vue&type=script&lang=js&"
export * from "./LiveClassBulkUploader.vue?vue&type=script&lang=js&"
import style0 from "./LiveClassBulkUploader.vue?vue&type=style&index=0&id=35c590e6&lang=postcss&scoped=true&"
import style1 from "./LiveClassBulkUploader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c590e6",
  null
  
)

export default component.exports